const ACADEMY_URL = process.env.API_URL + '/academy';
const ACADEMY_SHORT_URL = process.env.API_URL + '/academy/post/short';
const ACADEMY_RECOMMENDED_URL = ACADEMY_URL + '/recommended';

const getPosts = (context, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ACADEMY_SHORT_URL, {params: {lang: lang}}).then((posts) => {
      resolve(posts);
    }, error => {
      reject(error);
    });
  });
};

const getUserRecommendedPosts = (context, userId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ACADEMY_RECOMMENDED_URL + '/' + userId).then((posts) => {
      resolve(posts);
    }, error => {
      reject(error);
    });
  });
};

const updateUserRecommendedPosts = (context, userId, posts) => {
  return new Promise((resolve, reject) => {
    context.$http.put(ACADEMY_RECOMMENDED_URL + '/' + String(userId), posts).then((posts) => {
      resolve(posts);
    }, error => {
      reject(error);
    });
  });
};

export default {
  getPosts,
  getUserRecommendedPosts,
  updateUserRecommendedPosts
};



// WEBPACK FOOTER //
// ./src/brand/health/api/academy/index.js